import React from "react";
import Content from "./Components/Content";
import classes from './css/Contact.module.css';

export const Contact = () => {
  return (
    <div>
      <Content>
        <h2 className={classes.title}>Website designed and developed by elMidori:</h2>
        <br />
        <div className={classes.buttonsWrapper}>
          <a
            className={classes.github}
            href="https://github.com/Elmidori"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-github"></i> Elmidori
          </a>
          <a
            className={classes.linkedin}
            href="https://www.linkedin.com/in/anass-azizi-363a6419a/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-linkedin"></i> Anass Azizi
          </a>
          <a
            className={classes.portfolio}
            href="#"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fas fa-globe"></i> Portfolio
          </a>




        </div>
      </Content>
    </div>
  );
};

export default Contact;
